const TOUR_STATES = {
  preTour: 'pre-tour',
  postTour: 'post-tour',
  duringTour: 'during-tour',
  fullCashflowReviewFinished: 'full-cashflow-review-finished',
};

const state = {
  tourState: TOUR_STATES.preTour,
};

const getters = {
  isPreTour: state => state.tourState === TOUR_STATES.preTour,
  isDuringTour: state => state.tourState === TOUR_STATES.duringTour,
  isPostTour: state => state.tourState === TOUR_STATES.postTour,
};

const actions = {
  setDuringTour({ commit }) {
    commit('setDuringTour');
  },
  setPostTour({ commit }) {
    commit('setPostTour');
  },
  setFullCashflowReviewFinished({ commit }) {
    commit('setFullCashflowReviewFinished');
  },
};

const mutations = {
  setDuringTour(state) {
    state.tourState = TOUR_STATES.duringTour;
  },
  setPostTour(state) {
    state.tourState = TOUR_STATES.postTour;
  },
  setFullCashflowReviewFinished(state) {
    state.tourState = TOUR_STATES.fullCashflowReviewFinished;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
